import { VIEWER_ACTIVE_WINDOW_MS, type ActiveViewer, type QueueItem } from '@rp/contracts'

export const isUntouched = (item: QueueItem): boolean =>
  item.viewedAt === null || Date.parse(item.viewedAt) < Date.parse(item.lastMessageAt)

export const activeViewerOf = (item: QueueItem, now: Date): ActiveViewer | null => {
  if (item.activeViewer === null) return null
  const idle = now.getTime() - Date.parse(item.activeViewer.lastViewedAt)
  return idle > VIEWER_ACTIVE_WINDOW_MS ? null : item.activeViewer
}
